import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cdf8936")

_pushScopeId("data-v-2cdf8936")
const _hoisted_1 = { class: "flex justify-center checkout-success py4" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-column items-center"
}
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_7 = { class: "h4 flex align-center mb1 package__info-wrapper" }
const _hoisted_8 = { class: "package__info mr2" }
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "h4 flex align-center mb1 package__info-wrapper" }
const _hoisted_11 = { class: "package__info mr2" }
const _hoisted_12 = { class: "bold" }
const _hoisted_13 = { class: "h4 flex align-center mb1 package__info-wrapper" }
const _hoisted_14 = { class: "package__info mr2" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "h4 flex align-center mb1 package__info-wrapper" }
const _hoisted_17 = { class: "package__info mr2" }
const _hoisted_18 = { class: "bold" }
const _hoisted_19 = { class: "h4 flex align-center mb1 package__info-wrapper" }
const _hoisted_20 = { class: "package__info mr2" }
const _hoisted_21 = { class: "bold" }
const _hoisted_22 = {
  key: 0,
  class: "h4 flex align-center mb1 package__info-wrapper"
}
const _hoisted_23 = { class: "package__info mr2" }
const _hoisted_24 = { class: "my2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoSpinner = _resolveComponent("LogoSpinner")!
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LogoSpinner, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('checkout.success.title')), 1),
          _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('checkout.success.description')), 1),
          _createVNode(_component_BaseBox, { class: "flex mt2 mb3 box" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                ($setup.tokenData)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('checkout.price')), 1),
                        _createVNode("div", _hoisted_9, _toDisplayString($setup.tokenData.package.price) + " " + _toDisplayString($setup.tokenData.package.currency), 1)
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('checkout.priceGross')), 1),
                        _createVNode("div", _hoisted_12, _toDisplayString(($setup.tokenData.package.price * 1.23).toFixed(2)) + " " + _toDisplayString($setup.tokenData.package.currency), 1)
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('checkout.success.yourSubscription')), 1),
                        _createVNode("div", _hoisted_15, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.tokenData.package.gamesInPackage, (value, key) => {
                            return (_openBlock(), _createBlock("div", { key: key }, _toDisplayString(value) + " x " + _toDisplayString($setup.GAME_NAMES_HUMANIZED[key]), 1))
                          }), 128))
                        ])
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('checkout.success.mode')), 1),
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('checkout.withRegister.freePackage')), 1)
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('checkout.success.boughtOn')), 1),
                        _createVNode("div", _hoisted_21, _toDisplayString($setup.formatDate($setup.tokenData.package.boughtOn)), 1)
                      ]),
                      ($setup.tokenData.referralCodeUsedDuringRegistration)
                        ? (_openBlock(), _createBlock("div", _hoisted_22, [
                            _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('checkout.success.referralBonus')), 1),
                            _createTextVNode(" " + _toDisplayString($setup.referMoneyForBuyer) + " " + _toDisplayString($setup.tokenData.package.currency), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('checkout.success.invoice')), 1),
          _createVNode(_component_Button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/dashboard')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('checkout.success.backToDashboard')), 1)
            ]),
            _: 1
          })
        ]))
  ]))
})